import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type CourseMembershipAttrs = {
  id: number
  courseId: number
  studentId: number
}

// Drops the deprecated kebab-case keys the API still sends, so they don't leak into app state.
const dropKebabCaseKeys = ({
  id,
  studentId,
  courseId
}: FancyOk<fancyOperations['getCourseMembershipsR']>[0]): CourseMembershipAttrs => ({
  id,
  studentId,
  courseId
})

export const fetchCourseMemberships = (): Promise<Array<CourseMembershipAttrs>> =>
  fancyClient
    .GET('/2/course-memberships')
    .then(extractData)
    .then(data => data.map(dropKebabCaseKeys))
